import {IValuesStore} from "Stores/Values/types";
import {IManagementStore} from "Stores/Management/types";
import {inject, observer} from "mobx-react";
import React from "react";
import {DeploymentInstructionsContainer} from "./styles";
import {Values} from "@src/Tools/Values";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Link} from "@material-ui/core";
import {Location} from "@src/Interfaces/Entity/Location";
import {observable} from "mobx";

interface IDeploymentInstructions {
  location: Location;
  values?: IValuesStore;
  management?: IManagementStore;
}

@inject("values", "management")
@observer
export class DeploymentInstructions extends React.Component<IDeploymentInstructions> {
  @observable scriptText: string = '';
  @observable documentationLink: string = '';
  @observable isFileDownloaded: boolean = false;
  @observable showConfirmDialog: boolean = false

  async componentDidMount() {
    const response = await this.props.management.getDeploymentInstructionsData();
    this.documentationLink = response.documentationLink || '';
    this.scriptText = response.scriptText || '';
  }


  async getAndDownloadDeploymentFile() {
    this.showConfirmDialog = false;
    await this.props.management.downloadEnvironmentVariables(this.props.location.id);
    this.isFileDownloaded = true;
  }

  async copyScriptToClipboard() {
    await navigator.clipboard.writeText(this.scriptText);
  }

  async downloadButtonClickHandler() {
    if (this.isFileDownloaded) {
      this.handleShowConfirmDialog();
    } else {
      await this.getAndDownloadDeploymentFile();
    }
  }

  handleShowConfirmDialog() {
    this.showConfirmDialog = true;
  }

  handleCloseConfirmDialog() {
    this.showConfirmDialog = false;
  }

  render() {
    return (
      <>
        <DeploymentInstructionsContainer id={"deployment-instructions-container"}>
          <div className="download-file">
          <span>
            {Values.getLocalizationValue('pleaseDownloadFileAndCopyToServer')}
          </span>
            <RoundButton
              icon={<GetAppIcon/>}
              tooltipTitle={Values.getLocalizationValue("download")}
              color="green"
              onClick={this.downloadButtonClickHandler.bind(this)}
            />
          </div>

          <div className="label-with-code-box">
            <span>{Values.getLocalizationValue('thenExecuteThisScriptInSameFolder')}:</span>
            <div className="code-box">
              <code>{this.scriptText}</code>
              <RoundButton
                icon={<FileCopyIcon/>}
                tooltipTitle={Values.getLocalizationValue("copy")}
                color="gray"
                onClick={this.copyScriptToClipboard.bind(this)}
              />
            </div>
          </div>
          <div className="documentation-link">
            <span>{Values.getLocalizationValue('forDetailedInformationYouCanLookAtThe')}&nbsp;</span>
            <Link href={this.documentationLink}>
              {Values.getLocalizationValue('documentation').toLowerCase()}
            </Link>
          </div>
        </DeploymentInstructionsContainer>

        <Dialog
          maxWidth={false}
          open={this.showConfirmDialog}
          onClose={this.handleCloseConfirmDialog.bind(this)}
          style={{padding: 24}}
        >
          <DialogTitle id="person-dialog-title">
            {Values.getLocalizationValue("confirm")}
          </DialogTitle>

          <DialogContent>
            {Values.getLocalizationValue("previouslyDownloadedSecretsWillBeInvalid")}
          </DialogContent>

          <DialogActions style={{padding: 24}}>
            <Button
              variant={"outlined"}
              onClick={this.handleCloseConfirmDialog.bind(this)}
              color="default"
            >
              {Values.getLocalizationValue("cancel")}
            </Button>

            <Button
              variant={"contained"}
              onClick={this.getAndDownloadDeploymentFile.bind(this)}
              color="primary"
            >
              {Values.getLocalizationValue("confirm")}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}